
import Vue from "vue";
import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
} from "vue-property-decorator";
import { ComputeJob } from "../../model";
// import VueMarkdown from 'vue-markdown';

@Component({
  // components: {'vue-markdown': VueMarkdown},
  filters: {},
})
export default class ExpiryDialog extends Vue {
  @Prop({ type: Object })
  job: ComputeJob;

  @Prop({ default: null, type: String })
  openFrom: string | null;

  @Prop({ default: null, type: String })
  closeTo: string | null;

  open() {
    // console.log('Opened: ' + refName);
    ((this.$refs as any)["thisDialog"] as any).open();
  }

  close() {
    // console.log('Closed: ' + refName);
    ((this.$refs as any)["thisDialog"] as any).close();
  }
}
